<template>
    <ul class="tab-menu">
        <li class="tab-menu__item active">
            <router-link to="/kr/mypage/babyNote/babyDiary">산모일기</router-link>
        </li>
        <li class="tab-menu__item">
            <router-link to="/kr/mypage/babyNote/checkupRecord">검진기록</router-link>
        </li>
        <li class="tab-menu__item">
            <router-link to="/kr/mypage/babyNote/birthRecord">출산기록</router-link>
        </li>
    </ul>
    <div class="info">
        <div class="my__blood-top">
            <div class="blood-calendar">
                <div class="blood-calendar__top">
                    <a href="javascript:;" class="blood-calendar--today" @click="todayCalendar">오늘</a>
                    <a href="javascript:;" class="blood-calendar--button prev" @click="prevCalendar"></a>
                    <h4 class="title02">{{ calYear }}-{{ calMonth }}</h4>
                    <a href="javascript:;" class="blood-calendar--button next" @click="nextCalendar"></a>
                </div>
                <table class="blood-calendar__body">
                    <caption> 예약일 선택 테이블 </caption>
                    <colgroup>
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                        <col width="14.29%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>일</th>
                            <th>월</th>
                            <th>화</th>
                            <th>수</th>
                            <th>목</th>
                            <th>금</th>
                            <th>토</th>
                        </tr>
                    </thead>
                    <tbody>
                        <!-- td classList - none: 지난달, 다음달 / on:  측정기록이 있는날 / active -->
                        <tr v-for="item in arrChunk(calendarList)" :key="item">
                            <td v-for="i in item" :key="i" :class="[i.dayType, { 'active': i.text == activeIndex }]">
                                <a href="javascript:;" @click="[selectDate(i), activeIndex = i.text]">
                                    {{ i.day }}
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="blood-calendar__bottom">
                    <p>
                        <span class="c-red">*</span> 조회 및 등록을 원하시는 날짜를 선택해주세요.
                    </p>
                    <div class="blood-calendar__state">
                        <div class="blood-calendar__state__item">
                            <span></span>
                            기록
                        </div>
                        <div class="blood-calendar__state__item">
                            <span></span>
                            오늘
                        </div>
                    </div>
                </div>
            </div>
            <div class="headbook">
                <div class="headbook__top">
                    <h4 class="title02">{{ diaryCount }} 개의 기록</h4>
                    <router-link to="/kr/mypage/babyNote/babyDiaryRegister"
                        class="main-button small c-main">기록하기</router-link>
                </div>
                <div class="mother-diary-wrap">
                    <ul class="mother-diary">
                        <li class="mother-diary__item" v-for="item in sliceList(diaryList)" :key="item">
                            <a href="javascript:;" :class="{'active': diaryDetail.bdSn == item.bdSn}" @click="selectDate(item)">
                                <div class="mother-diary--img">
                                    <img :src="`/displayFile.do?attachNo=${item.attachBag.attach[item.attachBag.attach.length - 1].attachNo}`"
                                        :alt="item.attachBag.attach[item.attachBag.attach.length - 1].altValue || '이미지'"
                                        v-if="item.attachBag.attach" />
                                </div>
                                <p class="mother-diary--title">{{ $commonUtils.dateToStr(new Date(item.logDt), '.') }}</p>
                            </a>
                        </li>
                    </ul>
                    <kr_Pagination :totCnt="diaryCount" :pageRow="pageRow" :currentNum="currentNum" :pageCount="pageCount"
                        @setNum="setNum" />
                </div>
            </div>
        </div>
    </div>
    <div class="info" v-if="mode == 'show'">
        <div class="table-wrap">
            <div class="table headtable">
                <table>
                    <colgroup>
                        <col style="width:25%;">
                        <col style="width:75%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th class="" colspan="2">
                                <div class="headtable__header">
                                    <h4 class="title02">{{ $commonUtils.dateToStr(new Date(diaryDetail.logDt), '-') }}
                                    </h4>
                                    <div class="botton-wrap">
                                        <a href="javascript:;" class="main-button small c-gray" @click="delItems">삭제</a>
                                        <router-link :to="`/kr/mypage/babyNote/babyDiaryRegister?bdSn=${diaryDetail.bdSn}`" class="main-button small c-main" >수정</router-link>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="diaryDetail.attachBag.attach">
                            <td colspan="2">
                                <div class="mother-diary__photo">
                                    <ul class="mother-diary__photo-main">
                                        <li class="active">
                                            <img :src="`/displayFile.do?attachNo=${diaryAttach.attachNo}`"
                                                :alt="diaryAttach.altValue || '이미지'" v-if="diaryAttach.attachNo" />
                                        </li>
                                    </ul>
                                    <ul class="mother-diary__photo-sub">
                                        <li :class="{ 'active': attach.attachNo == diaryAttach.attachNo }"
                                            v-for="attach in diaryDetail.attachBag.attach" :key="attach">
                                            <a href="javascript:;" @click="selectAttach(attach)">
                                                <img :src="`/displayFile.do?attachNo=${attach.attachNo}`"
                                                    :alt="attach.altValue || '이미지'" />
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="diaryDetail.memo">
                            <th>
                                <h4 class="title03">메모</h4>
                            </th>
                            <td class="left">{{ diaryDetail.memo }}</td>
                        </tr>
                        <tr v-if="diaryDetail.weight">
                            <th>
                                <h4 class="title03">체중</h4>
                            </th>
                            <td class="left">
                                <span class="title03 font-sub">{{ diaryDetail.weight }}</span> kg
                            </td>
                        </tr>
                        <tr v-if="diaryDetail.mood">
                            <th>
                                <h4 class="title03">기분</h4>
                            </th>
                            <td>
                                <ul class="head-symptom__list">
                                    <li v-for="(item, idx) in diaryDetail.moodList" :key="item">
                                        <div :class="`icon mother-mood${('0' + (idx + 1)).slice(-2)}`"></div>
                                        <p>{{ item }}</p>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                        <tr v-if="diaryDetail.fig">
                            <th>
                                <h4 class="title03">건강상태</h4>
                            </th>
                            <td>
                                <ul class="head-symptom__list">
                                    <li v-for="(item, idx) in diaryDetail.figList" :key="item">
                                        <div :class="`icon mother-state${('0' + (idx + 1)).slice(-2)}`"></div>
                                        <p>{{ item }}</p>
                                    </li>
                                </ul>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="info">
        <h3 class="bullet01">체중 그래프</h3>
        <div class="table-search">
            <VueDatePicker v-model="selectedDateRange" locale="ko" :enable-time-picker="false" :format="customFormat"
                :week-start="0" :day-class="getDayClass" :select-text="'선택'" :cancel-text="'취소'" :range="true"
                :multi-calendars="true" placeholder="날짜를 선택하세요."/>
            <ul class="table-select__button-wrap">
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 7 }"
                        @click="changePeriod(7)">1주일</a></li>
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 1 }"
                        @click="changePeriod(1)">1개월</a></li>
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 3 }"
                        @click="changePeriod(3)">3개월</a></li>
                <li><a href="javascript:;" :class="{ 'table-select--sub-btn': true, 'active': period == 6 }"
                        @click="changePeriod(6)">6개월</a></li>
            </ul>
        </div>
        <div class="blood-chart-wrap">
            <div class="blood-chart">
                <div>
                    <Line class="blood-chart-inner" :data="filteredChartData" :options="chartOptions" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Line } from 'vue-chartjs';
import {
    Chart as ChartJS,
    Title,
    Tooltip,
    Legend,
    LineElement,
    PointElement,
    LinearScale,
    CategoryScale,
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
ChartJS.register(Title, Tooltip, Legend, LineElement, PointElement, LinearScale, CategoryScale, ChartDataLabels);

export default {

    components: {
        VueDatePicker,
        Line,
    },
    data() {
        return {
            isMobile: false, // 모바일 여부를 체크할 변수
            selectedDateRange: [new Date(), new Date()], // 날짜 선택값
            customFormat: 'yyyy-MM-dd',  // 날짜 포맷
            chartData: {
                labels: ['2024-02-04', '2024-06-20', '2024-07-29'],
                datasets: [
                    {
                        label: 'HealthInfo 1',
                        backgroundColor: 'transparent',
                        borderColor: '#09847d',
                        pointBackgroundColor: '#fff',
                        data: [55.4, 59.5, 63.1,],
                        fill: false,
                        tension: 0.4,
                        borderWidth: 1,  // 선의 두께
                        pointRadius: 7,  // 포인트 크기
                        pointBorderWidth: 3,  // 포인트의 테두리 두께
                        datalabels: {
                            anchor: 'end',
                            align: (context) => {
                                return 'end';
                            },
                            formatter: (value) => value,
                            color: 'white',
                            backgroundColor: '#09847d',
                            borderRadius: 3,
                            padding: {
                                top: 4,
                                bottom: 2,
                                left: 8,
                                right: 8,
                            },
                            width: 200,
                            font: {
                                size: 16,
                                weight: '700',
                            },
                        },
                    },
                ],
            },
            chartOptions: this.getChartOptions(), // 초기 차트 옵션

            // 캘린더
            classList: '',
            startDate: '',
            endDate: '',
            today: new Date(),
            calendarList: '',
            calYear: '',
            calMonth: '',
            activeIndex: '',
            toDay: this.$commonUtils.getToday(),
            selectDay: '',

            diaryList: [],
            diaryCount: 0,

            mode: 'list',
            diaryDetail: '',
            diaryAttach: '',

            mood: [
                '즐거움', '행복', '기쁨', '설렘', '그럭저럭', '짜증', '뾰로통', '지침', '불안', '괴로움'
            ],
            fig: [
                '입덧', '구역질', '어지러움', '빈혈', '갈색출혈', '출혈', '태동', '당김', '변비', '부종', '요통', '몸상태 좋지않음', '두통', '복통', '졸음', '나른함', '불면증', '피부 트러블', '다리경련', '관절통', '가슴통증', '두근거림', '배변', '약물복용'
            ],

            period: 7,
            subDataList: [],

            pageRow: 6,
            currentNum: this.$route.query.currentNum || 1,
            pageCount: 5,
        };
    },
    watch: {
        selectedDateRange: {
            handler(newData) {                
                this.getChartList()
            }
        }
    },
    methods: {
        getChartList() {
            if(!this.selectedDateRange[0] || !this.selectedDateRange[0]){
                return
            }
            var searchParam = {
                'inqrStrtYmd': this.$commonUtils.dateToStr(this.selectedDateRange[0], ''),
                'inqrFnshYmd': this.$commonUtils.dateToStr(this.selectedDateRange[1], '')
            };

            this.subDataList = []
            this.diaryList.forEach(item => {
                item.logDay = this.$commonUtils.dateToStr(new Date(item.logDt), '')
                if (searchParam.inqrStrtYmd <= item.logDay && searchParam.inqrFnshYmd >= item.logDay) {
                    this.subDataList.push(item);
                }
            });

            this.chartData.labels = []
            this.chartData.datasets[0].data = []
            for (let i of this.subDataList.sort((a, b) => a.logDay - b.logDay)) {
                this.chartData.labels.push(this.$commonUtils.makeDateFormat(i.logDay, '-'))
                this.chartData.datasets[0].data.push(Number(i.weight).toFixed(1))
            }

            
        },
        changePeriod(_period) {
            this.period = _period;
            var startDate = new Date();
            var endDate = new Date();

            if (this.period == 7) {
                startDate.setDate(startDate.getDate() - this.period);
            } else {
                startDate.setMonth(startDate.getMonth() - this.period);
            }

            this.selectedDateRange = [startDate, endDate];
            this.getChartList();
        },
        delItems() {
            if (confirm('기록을 삭제하시겠습니까?')) {
                this.axios({
                    method: "post",
                    url: this.api.mypage.diaryDel,
                    params: { 'bdSn': this.diaryDetail.bdSn }
                }).then(response => {
                    for (let i of this.calendarList) {
                        if(i.text == this.diaryDetail.logDay){
                            i.dayType = i.dayType.replace('on', '')
                            delete i.bdSn;
                            this.mode = 'list'
                        }
                    }
                    this.getList();
                });
            }
        },
        selectAttach(item) {
            this.diaryAttach = item
        },
        selectDate(item) {
            if (item.bdSn) {
                this.mode = 'show'
                for (let i of this.diaryList) {
                    if (i.bdSn == item.bdSn) {
                        this.diaryDetail = i
                        if(i.attachBag.attach){
                            this.diaryAttach = i.attachBag.attach.reduce((min, current) => {
                                return current.attachNo < min.attachNo ? current : min;
                            });
                        }

                        const moodArr = i.mood.split(',')
                        const moodList = []
                        for (let i = 0; i < this.mood.length; i++) {
                            if (moodArr.includes(this.mood[i])) {
                                moodList.push(this.mood[i])
                            }
                        }

                        const figArr = i.fig.split(',')
                        const figList = []
                        for (let i = 0; i < this.fig.length; i++) {
                            if (figArr.includes(this.fig[i])) {
                                figList.push(this.fig[i])
                            }
                        }

                        this.diaryDetail.moodList = moodList
                        this.diaryDetail.figList = figList
                    }
                }
            } else {
                this.$store.commit('setDiaryDate', new Date(this.$commonUtils.makeDateFormat(item.text, '-')))
                this.$router.push('/kr/mypage/babyNote/babyDiaryRegister')
            }
        },
        // pagination emit
        setNum(n) {
            this.currentNum = n
        },
        sliceList(list){
            if(list.length == 0){
                return []
            }
            const endNum = this.currentNum * this.pageRow
            return list.slice(this.currentNum - 1, Math.min(endNum, this.diaryCount))
        },
        getList() {
            this.axios.get(this.api.mypage.diaryList)
                .then(res => {
                    this.diaryList = res.data.result.list
                    this.diaryCount = this.diaryList.length

                    this.classList = []
                    this.diaryList.forEach(item => {
                        const obj = {}
                        obj.text = this.$commonUtils.dateToStr(new Date(item.logDt), '')
                        obj.date = item.logDt
                        obj.dayType = 'on'
                        obj.bdSn = item.bdSn
                        this.classList.push(obj)
                    });

                    if (this.classList) {
                        for (let i of this.calendarList) {
                            for (let j of this.classList) {
                                if (i.text == j.text) {
                                    i.dayType += ` ${j.dayType}`
                                    i.bdSn = j.bdSn
                                }
                            }
                        }
                    }
                    console.log('@@@@@@@@')
                    console.log(this.classList)
                    console.log(this.calendarList)
                    console.log('@@@@@@@@')

                    this.selectDay = this.toDay
                    this.getChartList()
                })
        },
        updateMobileStatus() {
            this.isMobile = window.innerWidth < 768; // 모바일 기준: 768px 이하
            this.chartOptions = this.getChartOptions(); // 차트 옵션 업데이트
        },
        getChartOptions() {
            if (this.isMobile) {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 40,
                            right: 30, // 모바일에서의 오른쪽 패딩
                            bottom: 0,
                            left: 0,
                        },
                    },
                    scales: {
                        y: {
                            title: {
                                display: true,
                                text: 'none',
                                padding: {
                                    top: -0,
                                    right: -40,
                                    left: 10,
                                },
                                font: {
                                    size: 0,
                                    weight: '400',
                                },
                            },
                            ticks: {
                                padding: 18, // 모바일에서의 ticks 패딩
                                font: {
                                    size: 14,
                                    weight: '400',
                                },
                            },
                            grid: {
                                display: true,
                                drawBorder: false,
                            },
                        },
                        x: {
                            ticks: {
                                padding: 10, // 모바일에서의 x축 ticks 패딩
                                font: {
                                    size: 16,
                                    weight: '500',
                                },
                            },
                            grid: {
                                display: false,
                                drawBorder: false,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                        },
                        datalabels: {
                            display: true,
                        },
                    },
                    elements: {
                        point: {
                            radius: 5, // 포인트 크기
                            hoverRadius: 5,
                            pointStyle: 'rectRot', // 마름모 형태
                            borderColor: 'red',    // 테두리 색상 (빨간색)
                            backgroundColor: 'white', // 배경 색상 (흰색)
                            borderWidth: 2,        // 테두리 두께
                        },
                    },
                };
            } else {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 0,
                            right: 115, // PC에서의 오른쪽 패딩
                            bottom: 0,
                            left: 0,
                        },
                    },
                    scales: {
                        y: {
                            title: {
                                display: true,
                                text: 'none',
                                padding: {
                                    top: -10,
                                    right: -100,
                                },
                                font: {
                                    size: 0,
                                    weight: '400',
                                },
                            },
                            ticks: {
                                padding: 50, // PC에서의 ticks 패딩
                                font: {
                                    size: 16,
                                    weight: '400',
                                },
                                maxTicksLimit: 6
                            },
                            grid: {
                                display: true,
                                drawBorder: false,
                            },
                        },
                        x: {
                            ticks: {
                                padding: 20, // PC에서의 x축 ticks 패딩
                                font: {
                                    size: 18,
                                    weight: 'bold',
                                },
                            },
                            grid: {
                                display: false,
                                drawBorder: false,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            enabled: false,
                        },
                        datalabels: {
                            display: true,
                        },
                    },
                    elements: {
                        point: {
                            radius: 10, // 포인트 크기
                            hoverRadius: 5,
                            pointStyle: 'rectRot', // 마름모 형태
                            borderColor: 'red',    // 테두리 색상 (빨간색)
                            backgroundColor: 'white', // 배경 색상 (흰색)
                            borderWidth: 1,        // 테두리 두께
                        },
                    },
                };
            }
        },
        /**
         * 이번 달의 첫 날, 마지막 날 구하기
         */
        init() {
            this.startDate = new Date(this.today.getFullYear(), this.today.getMonth(), 1);
            this.endDate = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 0);
            this.createCalendar();
        },
        /**
         * 달력 생성
         */
        createCalendar() {
            this.activeIndex = ''
            this.calendarList = [];
            this.calYear = this.today.getFullYear();
            this.calMonth = this.$commonUtils.leftPad(this.today.getMonth() + 1);

            if (this.startDate.getDay() > 0) {
                let preLastSunDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), ((this.startDate.getDay() - 1) * -1));
                let preLastDate = new Date(preLastSunDate.getFullYear(), preLastSunDate.getMonth() + 1, 0);

                // 지난달 구하기
                for (let preDay = preLastSunDate; preDay <= preLastDate; preDay.setDate(preDay.getDate() + 1)) {
                    let date = {
                        year: preDay.getFullYear(),
                        month: this.$commonUtils.leftPad(preDay.getMonth() + 1),
                        day: this.$commonUtils.leftPad(preDay.getDate()),
                        week: preDay.getDay(), // 0~6
                        text: this.$commonUtils.dateToStr(preDay, ''),
                        dayType: 'none'
                    }

                    this.calendarList.push(date);
                }
            }

            let today = new Date();
            today.setHours(0, 0, 0, 0); // 시간 초기화

            // 이번달 구하기
            for (let nowDay = this.startDate; nowDay <= this.endDate; nowDay.setDate(nowDay.getDate() + 1)) {
                let date = {
                    year: nowDay.getFullYear(),
                    month: this.$commonUtils.leftPad(nowDay.getMonth() + 1),
                    day: this.$commonUtils.leftPad(nowDay.getDate()),
                    week: nowDay.getDay(),
                    text: this.$commonUtils.dateToStr(nowDay, ''),
                    dayType: ''
                }

                if (nowDay < today) {
                    // date.dayType = "pastDay";
                } else if (nowDay.getFullYear() == today.getFullYear()
                    && nowDay.getMonth() == today.getMonth() && nowDay.getDate() == today.getDate()) {
                    date.dayType = "today";
                } else {
                    // date.dayType = "futureDay";
                }

                this.calendarList.push(date);
            }

            // 다음달 구하기
            if (this.endDate.getDay() < 6) {
                let nextFirstDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth() + 1, 1);
                let nextFirstSunDate = new Date(nextFirstDate.getFullYear(), nextFirstDate.getMonth(), ((this.endDate.getDay() - 7) * -1) - 1);

                for (let nextDay = nextFirstDate; nextDay <= nextFirstSunDate; nextDay.setDate(nextDay.getDate() + 1)) {
                    let date = {
                        year: nextDay.getFullYear(),
                        month: this.$commonUtils.leftPad(nextDay.getMonth() + 1),
                        day: this.$commonUtils.leftPad(nextDay.getDate()),
                        week: nextDay.getDay(),
                        text: this.$commonUtils.dateToStr(nextDay, ''),
                        dayType: 'none'
                    }

                    this.calendarList.push(date);
                }
            }

            // dayType에 class 부여
            const stringYear = this.calYear.toString()
            const stringMonth = this.calMonth.toString()
            if (this.classList) {
                for (let i of this.calendarList) {
                    for (let j of this.classList) {
                        if (i.text == j.text && i.year == stringYear && i.month == stringMonth) {
                            i.dayType += ` ${j.dayType}`
                        }
                    }
                }
            }
        },
        todayCalendar() {
            this.today = new Date();
            this.init();
            this.selectDay = this.toDay
        },
        prevCalendar() {
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() - 1, 1);
            this.init();
        },
        nextCalendar() {
            this.today = new Date(this.today.getFullYear(), this.today.getMonth() + 1, 1);
            this.init();
        },
        arrChunk(arr) {
            return arr.reduce(function (acc, val, index) {
                const chunkIndex = Math.floor(index / 7);
                if (!acc[chunkIndex]) {
                    acc[chunkIndex] = [];
                }
                acc[chunkIndex].push(val);
                return acc;
            }, []);
        },
    },
    created() {
        this.init()
        this.getList()
        this.changePeriod(7)
    },
    mounted() {
        this.updateMobileStatus(); // 초기 모바일 상태 확인
        window.addEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 등록
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateMobileStatus); // 리사이즈 이벤트 리스너 제거
    },
    computed: {
        filteredChartData() {
            return {
                ...this.chartData,
                datasets: [this.chartData.datasets[0]]
            }
        },
    },
};
</script>



<style scoped></style>